import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import VehicleAssignmentTable from './VehicleAssignmentTable';
import { TailSpin } from 'react-loader-spinner';
import NavMenu from './NavMenu';
import { useSimaTechContext } from './Context';
import { FetchData } from './DataAccess';

function VehicleAssignment() {
  const { state } = useSimaTechContext();
  const { vehicleId } = state;

  const [tableData, setTableData] = useState({ data: null, displayOverview: null });
  const [currentWeekNumber, setCurrentWeekNumber] = useState(0);

  const weeklyOverviewColumns = [{ id: 'dateParsed', label: 'Dato' }, { id: 'assignmentCount', label: 'Antal' }, { id: 'firstTask', label: 'Første stop' }, { id: '', label: 'Status' }]
  const workDayColumns = [{ id: 'workTime', label: 'Planlagt tid' }, { id: 'adviced', label: 'Adv.' }, { id: 'type', label: 'Type' }, { id: 'customerAddress', label: 'Adresse' }]

  useEffect(() => {
    getWeeklyOverview('WeeklyOverview')
  }, [vehicleId, currentWeekNumber]);

  const getWeeklyOverview = (displayOverview) => {
    const getWeeklyOverviewData = 'VehicleId=' + vehicleId + '&WeekNumber=' + currentWeekNumber;
    FetchData('GetWeeklyOverview', 'POST', getWeeklyOverviewData).then((result) => {
      if (result.errorMessage === null) {
        setTableData({ data: result.workDays, columns: weeklyOverviewColumns, dateSpanFormat: result.dateSpanFormat, displayOverview: displayOverview })
      } else {
        alert(result.errorMessage);
      }
    },
      (error) => {
        alert('Kunne ikke finde serveren. Prøv igen senere eller kontakt administratoren.');
      }
    );
  }

  const getWorkDayVehicle = (date) => {
    const getWorkDayVehicleData = 'vehicleId=' + vehicleId + '&date=' + date;
    FetchData('GetWorkDay', 'POST', getWorkDayVehicleData).then((result) => {
      if (result.errorMessage === null) {
        setTableData({ data: result.assignments, columns: workDayColumns, dateFormat: result.dateFormat, date: result.date, displayOverview: 'WorkDay' })
      } else {
        alert(result.errorMessage);
      }
    },
      (error) => {
        alert('Kunne ikke finde serveren. Prøv igen senere eller kontakt administratoren.');
      }
    );
  }          

  const handleDisplayOverview = (display) => {
    getWeeklyOverview(display)
  }
  const onWorkDayClick = (date) => {
    getWorkDayVehicle(date)
  }

  const handleNavigatePreviousPage = () => {
    setCurrentWeekNumber(currentWeekNumber - 1)
  }

  const handleNavigateNextPage = () => {
    setCurrentWeekNumber(currentWeekNumber + 1)
  }

  if (tableData.displayOverview === null) {
    return (
      <span style={{ 'zIndex': "9999", position: "absolute", top: "50%", left: "50%" }}>
        <TailSpin color="#00BFFF" height={80} width={80} /></span>)
  }

  return (
    <Container>
      <NavMenu />
      <Row className="py-4">
        <Col>
          <VehicleAssignmentTable
            onWorkDayClick={onWorkDayClick}
            tableData={tableData}                 
            currentWeekNumber={currentWeekNumber}
            handleDisplayOverview={handleDisplayOverview}
            handleNavigateNextPage={handleNavigateNextPage}
            handleNavigatePreviousPage={handleNavigatePreviousPage}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default VehicleAssignment;